'use client';

import { X } from 'lucide-react';
import type { FinderOpportunity } from '@/lib/types';
import { ServeArt } from './ServeCard';

/**
 * THE PAGE'S OWN BAND, ACROSS THE TOP OF A SHEET.
 *
 * The event-details widget's EventSheetBand, for an opportunity: the art
 * blown up and blurred behind, the poster in front, the title and a line
 * beside it, and a close button drawn for the dark. Anything the page opens
 * over itself should feel like the page, not a form on another site.
 */
export function SheetBand({
  opportunity,
  title,
  subtitle,
  onClose,
}: {
  opportunity: FinderOpportunity;
  title: string;
  subtitle?: string | null;
  onClose: () => void;
}) {
  return (
    <div className="relative overflow-hidden bg-[color-mix(in_srgb,var(--accent,#1c2b39)_45%,#1c2b39)] text-white">
      <div className="pointer-events-none absolute inset-0 scale-125 blur-2xl" aria-hidden="true">
        <ServeArt opportunity={opportunity} />
      </div>
      <div className="absolute inset-0 bg-black/45" aria-hidden="true" />
      <div className="relative flex items-center gap-3 px-5 pt-5 pb-4">
        <div className="aspect-video w-20 shrink-0 overflow-hidden rounded-xl shadow-lg ring-1 ring-white/20">
          <ServeArt opportunity={opportunity} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="truncate text-base font-extrabold">{title}</div>
          {subtitle && <div className="truncate text-xs text-white/70">{subtitle}</div>}
        </div>
        <button
          type="button"
          aria-label="Close"
          onClick={onClose}
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/15 text-white backdrop-blur transition hover:bg-white/25"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
